import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import EditIcon from '@mui/icons-material/Edit'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import Stack from '@mui/material/Stack'
import BasicModal from '../modal/BasicModal'
import Edit from './Edit'
import { DELETE_CONFIRM } from '../../constants/form'
import { checkUserRole } from '../../common/checkUserRole'
import { roleListId, roleType } from '../../config/roleList'
import { Button } from '@mui/material'
import AddNew from '../itemStyle/AddNew'
import { deleteItemCategory } from '../../store/actions/itemCategoryAction'
import ItemStyleList from '../itemStyle/ItemStyleList'

const ItemCategoryList = ({ itemCategory }) => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [editOpen, setEditOpen] = useState(false)
    const [styleOpen, setStyleOpen] = useState(false)

    const handleEdit = useCallback(() => {
        setEditOpen(true)
    }, [])

    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteItemCategory(id))
            }
        },
        [dispatch]
    )

    return (
        <>
            <BasicModal open={editOpen} setOpen={setEditOpen}>
                <Edit id={itemCategory.id} setOpen={setEditOpen} />
            </BasicModal>
            <BasicModal open={styleOpen} setOpen={setStyleOpen}>
                <AddNew
                    itemCategoryId={itemCategory.id}
                    setOpen={setStyleOpen}
                />
            </BasicModal>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{itemCategory.name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div
                        style={{
                            marginBottom: '10px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <EditIcon
                            onClick={() =>
                                checkUserRole(
                                    userInfo,
                                    roleList,
                                    roleListId.ITEM,
                                    roleType.EDIT
                                )
                                    ? handleEdit()
                                    : alert('Not Permit User')
                            }
                            style={{
                                marginRight: '20px',
                                cursor: 'pointer',
                            }}
                        />
                        {itemCategory?.itemstyles?.length === 0 && (
                            <DeleteForeverIcon
                                onClick={() =>
                                    checkUserRole(
                                        userInfo,
                                        roleList,
                                        roleListId.ITEM,
                                        roleType.DELETE
                                    )
                                        ? handleDelete(itemCategory.id)
                                        : alert('Not Permit User')
                                }
                                style={{
                                    color: 'red',
                                    cursor: 'pointer',
                                    marginRight: '20px',
                                }}
                            />
                        )}
                        <Button
                            color="secondary"
                            variant="outlined"
                            size="small"
                            onClick={() =>
                                checkUserRole(
                                    userInfo,
                                    roleList,
                                    roleListId.ITEM,
                                    roleType.CREATE
                                )
                                    ? setStyleOpen(true)
                                    : alert('Not Permit User')
                            }
                        >
                            Add New Item Style
                        </Button>
                    </div>
                    <Stack spacing={2}>
                        {itemCategory?.itemstyles?.length > 0 &&
                            itemCategory?.itemstyles?.map((itemStyle) => (
                                <ItemStyleList
                                    key={itemStyle.id}
                                    itemStyle={itemStyle}
                                />
                            ))}
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default ItemCategoryList
